/** @format */

import * as React from "react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

const defaultToastOptions: ToasterProps["toastOptions"] = {
  classNames: {
    toast:
      "bg-slate-900/85 text-slate-50 backdrop-blur-md border border-white/10 shadow-lg",
    title: "font-semibold",
    description: "text-slate-100/90 text-sm",
    actionButton:
      "bg-white/10 text-slate-50 hover:bg-white/20 border border-white/10",
    cancelButton:
      "bg-transparent text-slate-50 hover:bg-white/10 border border-white/10",
  },
};

const Toaster = ({
  position = "top-right",
  toastOptions,
  ...props
}: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      richColors
      style={
        {
          "--normal-bg": "rgba(15, 23, 42, 0.9)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "rgba(255, 255, 255, 0.08)",
          "--success-bg": "rgba(61, 183, 33, 0.79)",
          "--success-text": "#f8fafc",
          "--success-border": "rgba(16, 185, 129, 0.45)",
          "--error-bg": "rgba(139, 29, 29, 0.62)",
          "--error-text": "#f8fafc",
          "--error-border": "rgba(239, 68, 68, 0.45)",
          "--warning-bg": "rgba(234, 179, 8, 0.92)",
          "--warning-text": "#0f172a",
          "--warning-border": "rgba(202, 138, 4, 0.4)",
        } as React.CSSProperties
      }
      position={position}
      toastOptions={{
        ...defaultToastOptions,
        ...toastOptions,
        classNames: {
          ...defaultToastOptions?.classNames,
          ...toastOptions?.classNames,
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
